export default "__VITE_ASSET__DvIt436x__"